import { takeLatest, put, call } from 'redux-saga/effects';

import { buscarMovimentacoes, buscarPendentes, buscarIgnoradas } from '../service';
import { storage } from '@commons/storage';
import {
  NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA,
  NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA_PENDING,
  NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA_SUCCESS,
  NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA_FAILURE,
} from '../actionTypes';
import { CONFIG_SESSION } from '@handler/common/startSession';
import { formatDateDDMMYYYY } from '@components/common/format';

const CONST_FILTER_CONCILIACAO_BANCARIA = 'FILTER_CONCILIACAO_BANCARIA';

// Mapeamento das abas para os endpoints
const endpointMapping = {
  'movimentacoes': buscarMovimentacoes,
  'pendentes': buscarPendentes,
  'ignoradas': buscarIgnoradas,
};

function* sagaNewFilterNextPageConciliacaoBancaria(action) {
  yield put({ type: NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA_PENDING });

  try {
    const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;

    let filterSaved = sessionStorage.getItem(CONST_FILTER_CONCILIACAO_BANCARIA) !== null ?
      JSON.parse(sessionStorage.getItem(CONST_FILTER_CONCILIACAO_BANCARIA)) : null;

    const datas = formatDateDDMMYYYY(filterSaved.dataInicial) + '_' + formatDateDDMMYYYY(filterSaved.dataFinal);

    let newFilter = {
      ...filterSaved,
      rows: action.rows,
      page: action.page,
    };

    // Determina qual endpoint usar baseado na aba ativa
    const abaAtiva = newFilter.abaAtiva || 'pendentes';
    const endpointFunction = endpointMapping[abaAtiva];

    if (!endpointFunction) {
      throw new Error(`Endpoint não encontrado para a aba: ${abaAtiva}`);
    }

    // Busca registros usando o endpoint correto
    const filters = {
      contaBancoId: newFilter.contaBanco?.id ?? -1,
      dataInicio: newFilter.dataInicial,
      dataFim: newFilter.dataFinal
    };

    const whereParams = {
      tipoTransacao: newFilter.tipoTransacao,
      page: newFilter.page,
      size: newFilter.rows
    };

    let list = yield call(endpointFunction, filters, whereParams);

    sessionStorage.setItem(CONST_FILTER_CONCILIACAO_BANCARIA, JSON.stringify(newFilter));

    yield put({
      type: NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA_SUCCESS,
      list: list,
      filter: newFilter
    });
  } catch (error) {
    console.error('Erro na paginação de conciliação bancária:', error);
    yield put({ type: NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA_FAILURE });
  }
}

export default function* watchNewFilterNextPageConciliacaoBancaria() {
  yield takeLatest(NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA, sagaNewFilterNextPageConciliacaoBancaria);
}